export const styles = {
  mainBox: {
    position: 'absolute',
    right: '1rem',
    top: '5.5rem',
    width: '22rem',
    maxWidth: 'calc(100vw - 2rem)',
    maxHeight: '28rem',
    overflow: 'hidden',
    bgcolor: 'white',
    padding: '0.75rem',
    borderRadius: '0.75rem',
    boxShadow:
      'rgba(20, 20, 20, 0.15) 0rem 0.5rem 1.625rem -0.25rem, rgba(20, 20, 20, 0.06) 0rem 0.5rem 0.5625rem -0.3125rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '0.5rem',
  },
  title: {
    fontWeight: 700,
    fontSize: '1rem',
  },
  clearButton: {
    minWidth: 'auto',
    textTransform: 'none',
    fontSize: '0.8rem',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    overflowY: 'auto',
    pr: '0.25rem',
  },
  item: {
    border: '1px solid #e0e0e0',
    borderRadius: '0.75rem',
    padding: '0.75rem',
    backgroundColor: '#fafafa',
  },
  itemTitle: {
    fontWeight: 700,
    fontSize: '0.92rem',
    mb: '0.25rem',
  },
  itemMessage: {
    color: '#555',
    fontSize: '0.85rem',
    mb: '0.35rem',
  },
  itemDate: {
    color: '#888',
    fontSize: '0.75rem',
  },
  placeholderText: {
    color: 'rgba(0, 0, 0, 0.45)',
    textAlign: 'center',
    py: '1.25rem',
  },
};